import { connect } from 'react-redux';
import CetakSlipDetail from '../../../../views/Finance/Spp/LaporanKeu/CetakSlipDetail.laporaninvoice.view';
import { getAdjustmentJournal } from '../../../../states/thunks/finance.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAdjustmentJournal: payload => dispatch(getAdjustmentJournal(payload)),
  };
}

export default connect(null, mapDispatchToProps)(CetakSlipDetail);
